export const InstagramTextPercentileOptions = [
  { value: 'Very High', label: 'Very High' },
  { value: 'High', label: 'High' },
  { value: 'Average', label: 'Average' },
  { value: 'Low', label: 'Low' },
]

export type InstagramTextPercentileGroup =
  (typeof InstagramTextPercentileOptions)[number]['value']
